import { IGetPack } from '@/contracts/modules/education/use-case/IGetPack'
import { IPackRecord } from '@/contracts/modules/education/entities/IPackRecord'
import { GetPackRoute } from '@/modules/education/v1/api/v1/packs/GetPack/GetPackRoute'

export class GetPack implements IGetPack {
  async exec(): Promise<IPackRecord> {
    const response = await new GetPackRoute().exec(null)
    if (!response.isSuccess()) {
      throw new Error(response.getError())
    }
    return response.getData()
  }
}
